/* global Stripe */

// Native Stripe equivalent of three-ds-form.js (which drives Spreedly's 3DS
// lifecycle). The backend confirmed a SetupIntent that came back
// `requires_action`; here we run the 3DS challenge client-side and then
// resubmit so the backend can pick up the now-succeeded SetupIntent.
export default ({ publishableKey = undefined, clientSecret = undefined }) => ({
  async init() {
    this.stripe = Stripe(publishableKey);

    await this.start();
  },

  async start() {
    const result = await this.stripe.confirmCardSetup(clientSecret);

    if (result.error) {
      this.$dispatch(
        'flash-message',
        result.error.message || 'Card authentication failed. Please try again.'
      );
    }

    // On both success and failure we resubmit: the backend re-reads the
    // SetupIntent and either completes the purchase or surfaces the failure.
    this.$refs.form.submit();
  },
});
